import ENVIRONMENTS from '@/constants/environments';
import HOSTS from '@/constants/hosts';

export default function determineServerUrlFromLocation(): string {
  const host = window.location.host;

  if (host.includes('localhost')) {
    return HOSTS[ENVIRONMENTS.LOCAL];
  } else if (host.includes('staging')) {
    return HOSTS[ENVIRONMENTS.STAGING];
  } else {
    return HOSTS[ENVIRONMENTS.PRODUCTION];
  }
}
